// const API_BASE_URL = 'https://rollcallapis.azurewebsites.net/';
const BASE_URL = "https://perecoapi.cloudrollcall.in/";

const API_BASE_URL = BASE_URL + "portal/";

const ESSAPI_BASE_URL = BASE_URL + "ess/";
// const API_BASE_URL = "http://qaperecoapi.runasp.net/portal/";

export { API_BASE_URL,ESSAPI_BASE_URL };
